import { Bounce, Slide, toast, Zoom } from 'react-toastify';
import styles from './Toasts.module.scss';
import { isMobile } from 'react-device-detect';
import { managers } from '../user-config';


const onShareClick = (newOfferURL: string) => {
  if (navigator.share) {
    navigator.share({
      title: document.title,
      url: newOfferURL
    })
      .then(() => {
        console.log('Thanks for sharing!');
      })
      .catch(console.error);
  } else {
    console.log('Web Share API не поддерживается');
  };
};


export const savedToast = (newOfferURL: string) => toast.warn(
  <div>
    <p>Коммерческое создано.</p>
    <p>Ссылка скопирована в буфер!</p>
    {isMobile
      ? <button className={styles.shareBtn} onClick={() => onShareClick(newOfferURL)}>
        <b>Поделиться</b>
        <img height="30" src="assets/img/icons/share.svg" alt="share" />
      </button>
      : <>
        <h3 > Поделиться: </h3>
        <img style={{ cursor: 'pointer', margin: '0 6px' }}
          src="assets/img/icons/whatsapp.svg"
          height="30"
          alt='WhatsApp'
          onClick={() => window.open(`https://web.whatsapp.com://send?text=${newOfferURL}`)}
        />
        <img style={{ cursor: 'pointer' }}
          src="assets/img/icons/telegram.svg"
          height="30"
          alt='Telegram'
          onClick={() => window.open(`https://t.me/share/url?url=${newOfferURL}`)}
        />
      </>
    }
  </div>

  , {
    position: "top-center",
    autoClose: 5000,
    pauseOnHover: true,
    transition: Zoom,
  }
);



export const loginToast = (onSubmit: (event: React.FormEvent) => void) => toast.info(
  <div>
    <h4>👤 Введите пароль</h4>
    <form className={styles.inputForm} id="login" onSubmit={onSubmit}>
      <input name="inputname" autoComplete="off" type="password" autoFocus />
      <button type="submit" value="Submit" >
        <img src="assets/img/icons/next.svg" alt="next" />
      </button>
    </form>
  </div>

  , {
    position: "top-center",
    transition: Slide,
    progress: 1,
  }
);



export const errorToast = () => toast.error(
  <h4 style={{ marginLeft: '10px' }}>Неверный пароль!</h4>
  , {
    position: "top-center",
    transition: Bounce,
    autoClose: 500,
    pauseOnHover: false,
    hideProgressBar: true,
    closeButton: false,
  }
);



const getManagersSelectElement = (managers: string[]) => {
  let defaultManager = window.localStorage.getItem('defaultManager');
  if (defaultManager && managers.indexOf(defaultManager) > -1) {
    return <select name="manager" defaultValue={defaultManager}>
      {managers.map(el => <option key={el} value={el}>{el}</option>)}
    </select>
  } else {
    return <select name="manager" defaultValue={"Choose"}>
      <option disabled value="Choose">Выберите менеджера</option>
      {managers.map(el => <option key={el} value={el}>{el}</option>)}
    </select>
  }
};


const onSaveFormSubmit = (event: React.FormEvent, pushOffer: (arg: { manager: string, client: string }) => void) => {
  event.preventDefault();

  const formData = new FormData(event.target as HTMLFormElement);
  const manager = formData.get('manager')?.toString() ?? "";
  const client = formData.get('client')?.toString() ?? "";
  const formValues = {
    manager,
    client
  };

  pushOffer(formValues);
  window.localStorage.setItem('defaultManager', manager);

  const waitingImg = document.createElement('img');
  waitingImg.setAttribute("src", "assets/img/icons/waiting.svg");
  waitingImg.setAttribute("alt", "waiting");
  waitingImg.setAttribute("class", `${styles.waiting}`);

  const p = document.getElementById("saveOfferHeader") as HTMLParagraphElement;
  p.innerText = "Отправка...";

  const form = document.getElementById("saveOfferForm");
  form?.replaceChildren(waitingImg);
};


export const saveFormToast = (pushOffer: (arg: { manager: string, client: string }) => void) => toast.info(
  <div>
    <p id="saveOfferHeader">Заполните информацию о предложении</p>
    <form className={`${styles.inputForm} ${styles.offerInfo}`} id="saveOfferForm" onSubmit={event => onSaveFormSubmit(event, pushOffer)}>
      {getManagersSelectElement(managers)}
      <input name="client" placeholder="Имя клиента" autoComplete="off" type="text" autoFocus />
      <button type="submit" value="Submit">
        <img src="assets/img/icons/next.svg" alt="next" />
      </button>
    </form>
  </div >

  , {
    position: "top-center",
    transition: Slide,
    progress: 1,
  }

);